import React from "react";
import { Container } from "reactstrap";
import styles from "./ExclusaoDados.module.css";

const DataDeletionPage = () => {
    return (
        <Container className={styles.termsSection}>

            <section className={styles.section}>
                <p className={styles.sectionContent}>
                    Se você deseja solicitar a exclusão da sua conta e dos dados associados na <strong>GuardAí</strong>, siga os passos abaixo:
                </p>
                <ol className={styles.list}>
                    <li>Envie um e-mail para <strong>guardaigestao@gmail.com</strong> com o assunto "Exclusão de Dados". <u>Utilize o e-mail cadastrado.</u></li>
                    <li>No corpo do e-mail, solicite a exclusão da conta e dos seus dados.</li>
                </ol>
            </section>

            <section className={styles.section}>
                <h4 className={styles.sectionTitle}>Dados que serão excluídos</h4>
                <p className={styles.sectionContent}>
                    Ao solicitar a exclusão da sua conta, os seguintes tipos de dados serão permanentemente removidos:
                </p>
                <ul className={styles.list}>
                    <li>Informações pessoais (nome, e-mail, etc.)</li>
                    <li>Dados de atividade e histórico de uso</li>
                    <li>Outros dados associados à sua conta</li>
                </ul>
            </section>

            <section className={styles.section}>
                <h4 className={styles.sectionTitle}>Exceções legais</h4>
                <p className={styles.sectionContent}>
                    Alguns dados poderão ser mantidos por um período adicional devido a obrigações legais ou regulamentares, incluindo:
                </p>
                <ul className={styles.list}>
                    <li>Logs de acesso por motivos de segurança</li>
                </ul>
                <p className={styles.sectionContent}>
                    Esses dados serão mantidos de forma segura e somente pelo tempo estritamente necessário.
                </p>
            </section>
        </Container>
    );
};

export default DataDeletionPage;
